import { render, staticRenderFns } from "./SearchItemToShareDialog.vue?vue&type=template&id=25f1c3bc"
import script from "./SearchItemToShareDialog.vue?vue&type=script&lang=js"
export * from "./SearchItemToShareDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports